<template>
    <div class="users">
        <a class="create-order__backward" @click="router.go(-1)">Назад</a>
        <h3 class="create-user__title">Создание нового пользователя</h3>
        <form method="post" @submit.prevent="submit" class="create-user">
            <ul class="create-user__list">
                <!-- TODO поменять теги input на соответствующий компонент -->
                <li class="create-user__item">
                    <span class="create-user__text">Email</span>
                    <input class="input" :class="{error: errors.email}" @input="errors.email =''" v-model="createUser.email" type="email" placeholder="testmail@mail.ru" :clear="true" v-maska="emailMaskOptions">
                </li>
                <li class="create-user__item">
                    <span class="create-user__text">Логин</span>
                    <input class="input" :class="{error: errors.login}" @input="errors.login =''" v-model="createUser.login" type="text" placeholder="nickname">
                </li>
                <li class="create-user__item">
                    <span class="create-user__text">ФИО</span>
                    <input class="input" :class="{error: errors.fullname}" @input="errors.fullname =''" v-model="createUser.fullname" type="text" placeholder="Иванов Иван Иванович" :clear="true">
                </li>
                <li class="create-user__item">
                    <span class="create-user__text">Телефон</span>
                    <input class="input" :class="{error: errors.phone}" @input="errors.phone =''" v-model="createUser.phone" type="tel" placeholder="+7 (999) 999-99-99" :clear="true" v-maska="'+7 ### ###-##-##'">
                </li>
                <li class="create-user__item">
                    <span class="create-user__text">Пароль</span>
                    <span class="create-user__text-black">генерируется автоматически</span>
                </li>
                <li class="create-user__item">
                    <span class="create-user__text">Роль</span>
                    <div class="create-user__role">
                        <label class="radio">
                            <input type="radio" name="role" value="user">
                            Пользователь
                        </label>
                        <label class="radio">
                            <input type="radio" name="role" value="manager">
                            Менеджер
                        </label>
                        <label class="radio">
                            <input type="radio" name="role" value="chief_manager">
                            Главный менеджер
                        </label>
                        <label class="radio">
                            <input type="radio" name="role" value="admin">
                            Администратор
                        </label>
                    </div>
                </li>
                <li class="create-user__item">
                    <span class="create-user__text">Регион</span>
                    <v-select v-model="createUser.region" placeholder="Регион" :options="citiesNames"/>
                </li>
            </ul>
            <button-component class="create-user__button" buttonText="Добавить пользователя"/>
        </form>
    </div>
</template>
<script setup lang="ts">
import buttonComponent from '../shared/buttonComponent.vue';
import toast from "../app/lib/hooks/errorToast"
import axios from '../app/lib/api'
import { createUserShema } from '../app/lib/shemas/userShema'
import { useLoadingStore } from '../app/store/store'
import { UserRole } from '../app/lib/types/users'
import {onMounted, reactive, ref, watch} from 'vue'
import { Cities } from '../app/lib/types/cities'
import router from '../app/router/router'
import { vMaska } from 'maska/vue'
import { MaskInputOptions } from "maska"

const loading = useLoadingStore()
const createUser = ref({
    email: '',
    login: '',
    fullname: '',
    phone: '',
    region: 'ВН',
    role: 'Исполнитель',
    regionId: ''
})
const errors = ref({
    email: '',
    login: '',
    fullname: '',
    phone: '',
    region: '',
    role: '',
})
const citiesList = ref([] as unknown as Cities[])
const user = ref(true)
const roles = Object.values(UserRole)
let citiesNames = [] as unknown as string[]
const emailMaskOptions = reactive<MaskInputOptions>({
    mask: "A!@A.Z",
    tokens: {
        A: {
            pattern: /[A-Za-z0-9]/,
            multiple: true
        },
        Z: {
            pattern: /[a-z]/,
            multiple: true
        }
    }
})

onMounted(() => {
    axios.cities.getCitiesList()
    .then((r: any) => {
        citiesList.value = r.data
        citiesList.value.forEach((item) => {
            citiesNames.push(item.name)
        })
    })
    .catch((err: any) => {
        loading.load()
        toast('error', err + ' Не удалось получить список городов')
    })
})

const createNewUser = async () => {
    try {
        const res = await axios.users.createNewUser(createUser.value)
        toast('success', 'Пользователь создан')
    } catch (error: any) {
        toast('error', error.response.data.message)
    }
}

const submit = async () => {
    try {
        await createUserShema.validate(createUser.value, { abortEarly: false })
        errors.value = {
                    email: '',
                    login: '',
                    fullname: '',
                    phone: '',
                    region: '',
                    role: '',
        }
        return await createNewUser()
    } catch (error:any) {
        error.inner.forEach((error: any ) => {
                //@ts-ignore
                errors.value[error.path] = error.message;
        });
    }
}

watch(() => createUser.value.region, () => {
        if(createUser.value.region != "") {
            errors.value.region = ''
        }
})
</script>